import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { PROSPECTS_PATHS } from 'xen/routes';
import { NavBarLink } from '../nav-bar-link';
export const ProspectNavBarBody = () => {
    return (_jsx(_Fragment, { children: _jsx(NavBarLink, { active: location.pathname.startsWith(PROSPECTS_PATHS.root), icon: "ListCheck", label: "Applications", to: "/prospect-home" }) }));
};
